import axios from "axios";

// const api = "http://10.53.25.122:5000"
// const apiTesting = "http://10.53.26.148:5000"

/*
  PSEUDECODE TUKAR KADO BARU:
    1. FE GET DATA LIMIT 25 ATAU 30 BERISI PERSON YANG BELUM MEMILIKI KADO DAN NO KADO YG DIMILIKI BELUM DIBERIKAN (getKado null dan gifted false)
    2. SLOT DILAKUKAN UNTUK BERTUKAR KADO
    3. SETELAH SLOT SELESAI DILAKUKAN, AKAN DIDAPATKAN ARRAY OF USER ID DAN NO KADO YANG DIDAPAT
    4. FE POST KE SERVER ARRAY OF USER ID + NO KADO
    5. JIKA POST TELAH SUKSES, FE AKAN MEREFRESH UNTUK DAPAT DATA BARU
      >> SERVER AKAN MELEMPAR DATA PERSON YANG BELUM MENDAPATKAN KADO DAN KADO NYA BELUM DIBERIKAN
    DST
*/

export const fetchDataKado = async ({ commit }) => {
  try {
    // console.log(process.env.VUE_APP_API2, "<< CHECK")
    const { data } = await axios.get(
      `${process.env.VUE_APP_API2}/api/events?limit=30&page=1`
    );
    // const { data } = await axios.get(`${api}/api/events`)
    console.log(data, "<< data person di action");
    commit("SET_SLOT_DATA", data.data);
    // commit('fetchPerson', data.data)
  } catch (error) {
    console.log(error);
  }
};

export const updateDataKado = async ({ commit }, payload) => {
  try {
    console.log(payload, "<< CHECK PAYLOAD");
    const responseUpdateKado = await axios.post(
      `${process.env.VUE_APP_API2}/api/events/updateStatus`,
      {
        userId: payload.userId,
      }
    );
    const resUpdateNoKado = await axios.post(
      `${process.env.VUE_APP_API2}/api/events`,
      {
        data: payload.data,
      }
    );

    console.log(
      resUpdateNoKado,
      "<< CHECK RESPONSE AFTER UPDATE NO KADO STATUS"
    );
    console.log(responseUpdateKado, "<< CHECK RESPONSE AFTER UPDATE STATUS");
  } catch (error) {
    console.log(error);
  }
};
